import ObjectID from 'bson-objectid'
import moment from 'moment'

const dateFormat = moment => moment.unix()

export default {
  methods: {
    dbDoc (id) {
      return new Promise((resolve, reject) => {
        this.$pouch.get(id)
          .then(doc => resolve(Object.assign({}, doc)))
          .catch(err => reject(err))
      })
    },
    dbSave (store, data) {
      const date = moment()
      return new Promise((resolve, reject) => {
        let doc = Object.assign({ store }, data)
        if (!doc._id) doc._id = ObjectID.generate()
        if (!doc.created) doc.created = dateFormat(date)
        doc.updated = dateFormat(date)
        this.$pouch.put(doc).then(res => resolve(res)).catch(err => {
          if (err.reason) this.$f7.dialog.alert(err.reason, this.t('app.err'))
          if (err.message && err.message !== 'unknown') this.$f7.dialog.alert(err.message, this.t('app.err'))
          reject(err)
        })
      })
    },
    dbPatch (id, data) {
      const date = moment()
      return new Promise((resolve, reject) => {
        this.$pouch.get(id)
          .then(doc => {
            const updated = dateFormat(date)
            doc = Object.assign(doc, data, { updated })
            this.$pouch.put(doc)
              .then(res => resolve(res))
              .catch(err => reject(err))
          })
          .catch(err => reject(err))
      })
    },
    dbRemove (doc) {
      return new Promise((resolve, reject) => {
        if (!doc._id && !doc._rev) {
          const err = 'doc._id and doc._rev are required'
          this.$f7.dialog.alert(err, this.t('app.err'))
          reject(err)
        } else {
          this.dbPatch(doc._id, { _deleted: true })
            .then(res => resolve(res))
            .catch(err => {
              if (err.reason) this.$f7.dialog.alert(err.reason, this.t('app.err'))
              if (err.message && err.message !== 'unknown') this.$f7.dialog.alert(err.message, this.t('app.err'))
              reject(err)
            })
        }
      })
    }
  }
}
